import { useState, useEffect } from "react";
import type { DbEdition } from "@/types/database";
import { supabase } from "@/lib/supabase";

interface UseEditionsReturn {
  editions: DbEdition[];
  isLoading: boolean;
}

export function useEditions(): UseEditionsReturn {
  const [editions, setEditions] = useState<DbEdition[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    async function load() {
      const { data, error } = await supabase
        .from("editions")
        .select("*")
        .order("year", { ascending: true });

      if (!mounted) return;

      if (error) {
        console.error("Failed to fetch editions:", error.message);
        setIsLoading(false);
        return;
      }

      setEditions(data as DbEdition[]);
      setIsLoading(false);
    }

    load();

    return () => {
      mounted = false;
    };
  }, []);

  return { editions, isLoading };
}
